module.exports = __webpack_public_path__ + "img/10.374b5ff8.png";